import { notification } from 'antd';
import React, { ReactNode, useEffect } from 'react';

import {
  ACCESS_FORBIDDEN_NOTIFICATION_EVENT,
  type AccessForbiddenNotificationDetail,
  buildPermissionDeniedNotificationArgs,
  resolvePermissionDeniedNotificationParams,
} from './accessErrorNotification';

/**
 * Listens for `ACCESS_FORBIDDEN_NOTIFICATION_EVENT` and shows antd notifications via `useNotification()`, under Apollo,
 * so `AccessRequestLink` works in the description.
 */
export const AccessErrorNotificationApiHolder = ({ children }: { children: ReactNode }) => {
  const [notificationApi, contextHolder] = notification.useNotification();

  useEffect(() => {
    const onAccessForbidden = (event: Event) => {
      const { detail } = event as CustomEvent<AccessForbiddenNotificationDetail>;
      const params = resolvePermissionDeniedNotificationParams(detail.message, detail.meta);

      notificationApi.error(buildPermissionDeniedNotificationArgs(params));
    };

    window.addEventListener(ACCESS_FORBIDDEN_NOTIFICATION_EVENT, onAccessForbidden);

    return () => {
      window.removeEventListener(ACCESS_FORBIDDEN_NOTIFICATION_EVENT, onAccessForbidden);
    };
  }, [notificationApi]);

  return (
    <>
      {contextHolder}
      {children}
    </>
  );
};
